import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { PageStreamerEntry } from "./StreamerEntry";

export class StreamerPage
{
  _doc:Document;
  _entries:PageStreamerEntry[] = [];
  _path:string;

  process( doc:Document, path:string )
  {
    this._doc = doc;
    this._path = path;

    let hrefs = this._doc.querySelectorAll( 'tr td a[href^="https://twitchtracker.com/"]' );

    let set = new Set<Element>();

    hrefs.forEach(
      ( h )=>
      {
        let row = HTMLEditor.findParent( h, "tr" );

        if ( set.has( row ) )
        {
          return;
        }

        set.add( row );

        let entry = PageStreamerEntry.create( row, path );

        this._entries.push( entry );
      }
    );


  }


}